import HouseOutlinedIcon from "@mui/icons-material/HouseOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import StickyNote2OutlinedIcon from "@mui/icons-material/StickyNote2Outlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import KeyOffOutlinedIcon from "@mui/icons-material/KeyOffOutlined";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import AddTaskOutlinedIcon from "@mui/icons-material/AddTaskOutlined";

import { Box } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { useDeveloperContext } from "../../hook/useDeveloperContext";
import { useEffect } from "react";

const SideBar = () => {
  const location = useLocation();

  const { username, userEmail } = useDeveloperContext();

  return (
    <>
      {" "}
      <Box className="card p-4">
        <Box className="d-flex flex-wrap justify-content-between align-items-center gap-3">
          <Box className="text-break">
            <Box className="fw-medium fs-5">{username}</Box>
            <Box className="text-muted">{userEmail}</Box>
          </Box>
          <Box className="d-block d-lg-none">
            <button
              className="btn btn-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#asideNav"
              aria-controls="asideNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <i className="far fa-bars me-sm-1"></i>
              <span className="d-none d-sm-inline-block">Sidebar Menu</span>
            </button>
          </Box>
        </Box>
        <nav className="navbar-expand-lg">
          <Box className="collapse navbar-collapse flex-column" id="asideNav">
            <hr className="w-100 mt-6 mb-2" />
            <ul className="nav nav-pills nav-pills-flush flex-column w-100 gap-1 1px-n4">
              <li className="nav-item fw-medium text-uppercase small px-3 mt-4 mb-1">
                Account
              </li>
              <li className="nav-item">
                <Link
                  to="/myaccount"
                  className={`nav-link py-2 px-3 ${
                    location.pathname === "/myaccount" ? "active" : ""
                  }`}
                >
                  <HouseOutlinedIcon className="text-icon me-1" /> Account
                  Overview
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/mysettings"
                  className={`nav-link py-2 px-3 ${
                    location.pathname === "/mysettings" ? "active" : ""
                  }`}
                >
                  <AdminPanelSettingsOutlinedIcon className="text-icon me-1" />{" "}
                  Account Settings
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/myprofile"
                  id="ContentPlaceHolder1_account_sidebar_upcxscanConnect"
                  className={`nav-link py-2 px-3 not-implemented ${
                    location.pathname === "/myprofile" ? "active" : ""
                  }`}
                >
                  <AssignmentIndOutlinedIcon className="text-icon me-1" />{" "}
                  Public Profile
                </Link>
              </li>
              <li className="nav-item fw-medium text-uppercase small px-3 mt-4 mb-1">
                Lists
              </li>
              <li className="nav-item">
                <Link
                  to="/myaddress"
                  id="ContentPlaceHolder1_account_sidebar_watchList"
                  className={`nav-link py-2 px-3 ${
                    location.pathname === "/myaddress" ? "active" : ""
                  }`}
                >
                  <FavoriteBorderOutlinedIcon className="text-icon me-1" />{" "}
                  Watch List
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/mynotes_address"
                  id="ContentPlaceHolder1_account_sidebar_privateTag"
                  className={`nav-link py-2 px-3 not-implemented ${
                    location.pathname === "/mynotes_address" ? "active" : ""
                  }`}
                >
                  <StickyNote2OutlinedIcon className="text-icon me-1" />
                  Private Name Tags
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/mynotes_tx"
                  id="ContentPlaceHolder1_account_sidebar_txnPrivateNote"
                  className={`nav-link py-2 px-3 not-implemented ${
                    location.pathname === "/mynotes_tx" ? "active" : ""
                  }`}
                >
                  <InsertDriveFileOutlinedIcon className="text-icon me-1" /> Txn
                  Private Notes
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/mytokenignore"
                  id="ContentPlaceHolder1_account_sidebar_tokenIgnoreList"
                  className={`nav-link py-2 px-3 not-implemented ${
                    location.pathname === "/mytokenignore" ? "active" : ""
                  }`}
                >
                  <VisibilityOffOutlinedIcon className="text-icon me-1" /> Token
                  Ignore List
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/myadvancedfilters"
                  id="ContentPlaceHolder1_account_sidebar_advancedfilterList"
                  className={`nav-link py-2 px-3 not-implemented ${
                    location.pathname === "/myadvancedfilters" ? "active" : ""
                  }`}
                >
                  <FilterAltOutlinedIcon className="text-icon me-1" /> Advanced
                  Filter
                </Link>
              </li>
              <li className="nav-item fw-medium text-uppercase small px-3 mt-4 mb-1">
                Others
              </li>
              <li className="nav-item">
                <Link
                  to="/myapikey"
                  id="ContentPlaceHolder1_account_sidebar_apiKeys"
                  className={`nav-link py-2 px-3 ${
                    location.pathname === "/myapikey" ? "active" : ""
                  }`}
                >
                  <KeyOffOutlinedIcon className="text-icon me-1" /> API Keys
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/myverify_address"
                  id="ContentPlaceHolder1_account_sidebar_verifiedAddress"
                  className={`nav-link py-2 px-3 not-implemented ${
                    location.pathname === "/myverify_address" ? "active" : ""
                  }`}
                >
                  <VerifiedOutlinedIcon className="text-icon me-1" /> Verified
                  Addresses
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/mycustomabi"
                  id="ContentPlaceHolder1_account_sidebar_customAbi"
                  className={`nav-link py-2 px-3 not-implemented ${
                    location.pathname === "/mycustomabi" ? "active" : ""
                  }`}
                >
                  <AddTaskOutlinedIcon className="text-icon me-1" /> Custom ABIs
                </Link>
              </li>
            </ul>
          </Box>
        </nav>
      </Box>
    </>
  );
};

export default SideBar;
